var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.params.node.data.accountTypeName,"placement":"top"}},[(_vm.params.node.data.accountTypeName)?_c('i',{staticClass:"el-icon-warning"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }